import React from 'react'

const createImage = (imageSrc: string, alt: string, width = '100%') => (
  <img src={imageSrc} alt={alt} style={{ width }} />
);

export default createImage
